import { Link } from "react-router-dom";
import type { Video } from "@/types/video";
import { formatPlays } from "@/utils/video";

interface VideoCardProps {
  video: Video;
}

export default function VideoCard({ video }: VideoCardProps) {
  return (
    <Link
      to={`/detail/${video.id}`}
      className="group block cursor-pointer"
      data-video-card
    >
      <div className="relative w-full aspect-video rounded-lg overflow-hidden bg-background-200">
        <img
          src={video.cover}
          alt={video.title}
          title={`${video.title} - 西瓜视频`}
          className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <span className="absolute bottom-2 right-2 px-1.5 py-0.5 rounded bg-foreground-950/75 text-background-50 text-xs font-medium">
          {video.duration}
        </span>
        <div className="absolute inset-0 bg-foreground-950/0 group-hover:bg-foreground-950/15 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-all duration-300">
          <span className="w-12 h-12 rounded-full bg-primary-500 flex items-center justify-center">
            <i className="ri-play-fill text-background-50 text-2xl w-6 h-6 flex items-center justify-center"></i>
          </span>
        </div>
      </div>
      <h3 className="mt-2.5 text-sm font-medium text-foreground-900 leading-snug line-clamp-2 group-hover:text-primary-600 transition-colors">
        {video.title}
      </h3>
      <div className="mt-1.5 flex items-center gap-2 text-xs text-foreground-500 flex-wrap">
        <span className="inline-flex items-center gap-1">
          <i className="ri-play-circle-line text-sm"></i>
          {formatPlays(video.plays)}次播放
        </span>
        <span className="text-background-300">·</span>
        <span>{video.categoryName}</span>
      </div>
    </Link>
  );
}